import { API, get } from "../../config";

export const getContractDetail = async (contractId) => {
  try {
    const { data } = await get(`${API.CONTRACT_DETAILS}/` + contractId);
    return data.data;
  } catch (e) {
    return null;
  }
};
